import "./LoyaltyProgram.css";

function LoyaltyProgram(): JSX.Element {
    return (
        <div className="LoyaltyProgram">
			Lotalty program
        </div>
    );
}

export default LoyaltyProgram;
